<div class="position-relative h-100 d-flex flex-column">
  <app-section-loader [loading]="loading"></app-section-loader>
  <div class="mContent__header bg-primary py-3 px-5 flex-auto">
    <h1 class="text-white mb-1">Lesson Plans</h1>
    <div class="mControls">
      <div class="input-group mr-auto">
        <mat-form-field appearance="outline" class="input-white no-error">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input
            type="text"
            matInput
            [(ngModel)]="searchBase.search"
            (keyup.enter)="searchChange()"
            [placeholder]="activeView === 'curriculum' ? 'Search by Yearly Plan name' : 'Search by lesson name or number'"
            aria-label="Search"
          />
          <button
            *ngIf="searchBase.search"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="searchBase.search = ''; searchChange()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <mat-button-toggle-group [ngModel]="activeView" (ngModelChange)="activeViewChange($event)" class="mx-3 view-toggle">
        <mat-button-toggle value="lesson">Lesson Plans</mat-button-toggle>
        <mat-button-toggle value="curriculum">Yearly Plans</mat-button-toggle>
      </mat-button-toggle-group>
      <div *ngIf="loggedInUser !== tutorRoleId">
        <div class="mControls__right">
          <div class="input-group">
            <button class="pl-2 mr-2" mat-raised-button (click)="addNewCurriculum()">Add New Yearly Plan</button>
          </div>
          <div class="input-group">
            <button class="pl-2" mat-raised-button (click)="updateLesson(null)">Add New Lesson Plan</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Lesson Plans View -->
  <ng-container *ngIf="activeView === 'lesson'">
    <div
      *ngIf="filteredLessons?.length > 0"
      class="search-results flex-fill overflow-auto m-3"
      infiniteScroll
      [infiniteScrollDistance]="0.025"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
    >
      <table class="table no-wrap m-0 table--hover">
        <thead>
          <tr>
            <th scope="col">Lesson Number</th>
            <th scope="col">Lesson Name</th>
            <th scope="col" class="table-head-grade">Grade Level</th>
            <th scope="col" class="table-head-empty-label">&nbsp;</th>
            <th scope="col" class="table-head-empty-label">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let lesson of filteredLessons">
            <td (click)="goToLessonDetail(lesson.id)">{{ lesson.lesson_plan_number }}</td>
            <td (click)="goToLessonDetail(lesson.id)">{{ lesson.lesson_plan_name }}</td>
            <td (click)="goToLessonDetail(lesson.id)">
              <strong class="text-success">{{ lesson?.grade_id?.grade_level }}</strong>
            </td>
            <div *ngIf="loggedInUser !== tutorRoleId">
              <td>
                <a class="cursor-pointer icon-btn" (click)="updateLesson(lesson.id)" aria-hidden="false" aria-label="Edit">
                  <mat-icon matTooltip="Edit" aria-hidden="false" aria-label="Edit">edit</mat-icon>
                </a>
              </td>
              <td>
                <a class="cursor-pointer icon-btn" (click)="deleteLesson(lesson)" aria-hidden="false" aria-label="Delete">
                  <mat-icon matTooltip="Delete" aria-hidden="false" aria-label="Delete">delete</mat-icon>
                </a>
              </td>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="flex-fill d-flex flex-column align-items-center justify-content-center"
      *ngIf="!filteredLessons?.length && !loading"
    >
      <img src="assets/images/no-result.png" alt="" />
      <h3 class="text-center">No Records Found</h3>
    </div>
  </ng-container>

  <!-- Curriculum View -->
  <ng-container *ngIf="activeView === 'curriculum'">
    <div *ngIf="curricula?.length > 0" class="search-results flex-fill overflow-auto m-3">
      <table class="table no-wrap m-0 table--hover">
        <thead>
          <tr>
            <th scope="col">Yearly Plan Name</th>
            <th scope="col">Description</th>
            <th scope="col">Is Finished</th>
            <th scope="col" class="table-head-empty-label">&nbsp;</th>
            <th scope="col" class="table-head-empty-label">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let curriculum of filteredCurricula" class="cursor-pointer" (click)="goToCurriculumDetail(curriculum.id)">
            <td>{{ curriculum.curriculum_name }}</td>
            <td>{{ curriculum.description }}</td>
            <td>{{ curriculum.is_finished ? 'Yes' : 'No' }}</td>
            <div *ngIf="loggedInUser !== tutorRoleId">
              <td>
                <a class="cursor-pointer icon-btn" (click)="editCurriculum(curriculum.id); $event.stopPropagation()" aria-label="Edit">
                  <mat-icon matTooltip="Edit">edit</mat-icon>
                </a>
              </td>
              <td>
                <a class="cursor-pointer icon-btn" (click)="deleteCurriculum(curriculum); $event.stopPropagation()" aria-label="Delete">
                  <mat-icon matTooltip="Delete">delete</mat-icon>
                </a>
              </td>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex-fill d-flex flex-column align-items-center justify-content-center" *ngIf="!curricula?.length">
      <img src="assets/images/no-result.png" alt="" />
      <h3 class="text-center">No Yearly Plans Found</h3>
    </div>
  </ng-container>

  <div class="text-right flex-auto p-3 page-count">
    <span>{{ filteredLessons?.length }}</span> of
    <span>{{ filteredLessonCount }}</span>
  </div>
</div>
